import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e615552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newreceivertype" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { "data-test": "receiver-setup-type-heading" }, "What receiver are you setting up?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-test": "receiver-setup-type-text" }, "Select the receiver type you would like to add.", -1))
const _hoisted_4 = { class: "receiver-type-buttons flex-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-block",
  "data-test": "receiver-dont-have-these-text"
}, "Don’t have one of these?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receiver-type-buttons__icon-container" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 128 128",
    "data-test": "receiver-setup-type-apple4-icon"
  }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", { d: "M24.3,68.3h77.5c6.4,0,19.4-4.5,14.2-13.6c-3.3-5.8-7-10.7-10.7-15.1c-4.3-5.1-8.4-6.7-23.5-6.5H44.1\n                                                    C29,32.9,24,35,20.6,39.6c-3.4,4.6-7.2,9.3-10.5,15.1C4.8,63.9,17.9,68.3,24.3,68.3" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M71,74.8h27.9c6.7,0,17.5-2.4,18.2-7c0,0-2.4,13.3-3.6,18.7C111.7,95,97.4,95,93.8,95H69.5h-3H32.2c-3.6,0-17.9,0-19.8-8.5\n                                                    c-1.2-5.4-3.6-18.7-3.6-18.7c0.7,4.6,11.5,7,18.2,7h37.8C64.9,74.8,71,74.8,71,74.8z" })
    ])
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiever-type-apple4-button-text" }, "Apple TV HD/4K", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receiver-type-buttons__icon-container" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 128 128",
    "data-test": "receiver-setup-type-windows-icon"
  }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.5,100.6l41.5,6V66.8H12.5V100.6z M12.5,61.2h41.5V21.4l-41.5,6V61.2z M59.7,107.4l55.7,8.1V66.8H59.7V107.4z\n                                            M59.7,20.6v40.6h55.7V12.5L59.7,20.6z" })
    ])
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-windows-button-text" }, "Windows", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"receiver-type-buttons__icon-container\" data-v-3e615552><svg viewBox=\"0 0 128 128\" data-v-3e615552><g data-v-3e615552><path d=\"M24.3,68.3h77.5c6.4,0,19.4-4.5,14.2-13.6c-3.3-5.8-7-10.7-10.7-15.1c-4.3-5.1-8.4-6.7-23.5-6.5H44.1\n                                                C29,32.9,24,35,20.6,39.6c-3.4,4.6-7.2,9.3-10.5,15.1C4.8,63.9,17.9,68.3,24.3,68.3\" data-v-3e615552></path><path d=\"M71,74.8h27.9c6.7,0,17.5-2.4,18.2-7c0,0-2.4,13.3-3.6,18.7C111.7,95,97.4,95,93.8,95H69.5h-3H32.2c-3.6,0-17.9,0-19.8-8.5\n                                                c-1.2-5.4-3.6-18.7-3.6-18.7c0.7,4.6,11.5,7,18.2,7h37.8C64.9,74.8,71,74.8,71,74.8z\" data-v-3e615552></path></g></svg></div><span data-test=\"receiver-type-apple3-button-text\" data-v-3e615552>Apple TV 3/2</span>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receiver-type-buttons__icon-container" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 128 128" }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", { d: "M85.4,46.5L85.4,46.5c-4.1-2.5-8.7-4.4-13.7-5.4V5.7c0-0.5-0.4-1-1-1H56.4c-0.5,0-1,0.4-1,1v35.4C36.4,44.9,22,61.7,22,81.9\n                                c0,7.2,1.8,14,5.1,19.9l0,0c7.1,12.9,20.8,21.7,36.6,21.7c23,0,41.6-18.6,41.6-41.6C105.3,66.9,97.3,53.8,85.4,46.5z M67.3,63.7\n                                L67.3,63.7c-1.2-0.2-2.4-0.4-3.6-0.4c0,0,0,0,0,0C64.9,63.3,66.1,63.5,67.3,63.7z M63.6,64.2c7,0,13,4,15.9,9.9H63.6\n                                c-4.1,0-7.5,3.2-7.8,7.3l-6.1-10.4C53,66.8,58,64.2,63.6,64.2z M63.6,75.3c3.6,0,6.6,3,6.6,6.6c0,3.6-3,6.6-6.6,6.6s-6.6-3-6.6-6.6\n                                C57,78.3,60,75.3,63.6,75.3z M45.9,81.9c0-3.7,1.1-7,3-9.9l7.3,12.5c1.1,3,4,5.2,7.4,5.2c1.3,0,2.5-0.3,3.6-0.9l-6.1,10.5\n                                C52.5,98.2,45.9,90.8,45.9,81.9z M63.6,99.7c-0.4,0-0.8,0-1.2,0l8.1-13.9l0,0c0.6-1.1,1-2.4,1-3.8c0-2.8-1.4-5.2-3.6-6.6h12.2\n                                c0.8,2,1.3,4.3,1.3,6.6C81.4,91.7,73.4,99.7,63.6,99.7z" })
    ])
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-chromecast-button-text" }, "Chromecast", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receiver-type-buttons__icon-container" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 128 128" }, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", { d: "M17.2,78c-7.7,0-14-6.3-14-14s6.3-14,14-14s14,6.3,14,14S25,78,17.2,78z M49.8,64c0,7.7,6.3,14,14,14s14-6.3,14-14\n                                        s-6.3-14-14-14S49.8,56.3,49.8,64z M96.4,64c0,7.7,6.3,14,14,14s14-6.3,14-14s-6.3-14-14-14S96.4,56.3,96.4,64z" })
    ])
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-test": "receiver-type-other-button-text" }, "Other", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "mt-2 mb-4 m-auto d-block",
      type: "text",
      onClick: _ctx.onPreviousStep,
      "data-test": "receiver-back-to-pairing-code-button"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          class: "primary-color me-1",
          small: "",
          icon: _ctx.mdiArrowLeft
        }, null, 8, ["icon"]),
        _createTextVNode("Back to Pairing Code")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_popover, {
        trigger: "manual",
        placement: "left",
        "popper-class": "onboarding__popover width-auto",
        disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
        visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog
      }, {
        reference: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onReceiverTypeSelection('apple4'))),
            "data-test": "receiver-type-apple4-button"
          }, _hoisted_8)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _hoisted_5,
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.onContactUs,
              class: "contact-us-link white text-decoration-underline",
              "data-test": "receiver-contact-us-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Contact us.")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["disabled", "visible"]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onReceiverTypeSelection('windows'))),
        "data-test": "receiver-type-windows-button"
      }, _hoisted_11),
      (_ctx.legacyReceiversEnabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onReceiverTypeSelection('apple3'))),
            "data-test": "receiver-type-apple3-button"
          }, _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.legacyReceiversEnabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onReceiverTypeSelection('chromecast'))),
            "data-test": "receiver-type-chromecast-button"
          }, _hoisted_17))
        : _createCommentVNode("", true),
      (_ctx.legacyReceiversEnabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onReceiverTypeSelection('other'))),
            "data-test": "receiver-type-other-button"
          }, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ]))
}